import { translateFunc } from "client/utils/translateFunc";
import { MinusIcon } from "components/common/Icons/MinusIcon";
import { PlusIcon } from "components/common/Icons/PlusIcon";
import { Input } from "components/common/Input/Input";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFindTextBox } from "../useFindTextBox";
import { useFontSize } from "./useFontSize";

export interface FontSizeProps {
    textBoxId: string;
}

export const FontSize = ({ textBoxId }: FontSizeProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { handleChange, handleKeyUp, handleMinusClick, handlePlusClick } = useFontSize(textBox);
    return (
        <div className="flex items-center">
            <ToolTip text={translateFunc("decrease-font-size")}>
                <button
                    className="border border-irGray-200 dark:border-darkSurface-400 px-4 font-semibold h-10 rounded-l-xl flex items-center justify-center hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    onClick={handleMinusClick}
                >
                    <MinusIcon />
                </button>
            </ToolTip>
            <div className="pl-4 border-t border-b border-t-irGray-200 border-b-irGray-200 dark:border-darkSurface-400 flex items-center justfy-center text-center text-black dark:text-white dark:bg-darkSurface-100">
                <Input
                    type="number"
                    acceptFloat={true}
                    value={textBox.fontSize}
                    className="focus:outline-0 dark:bg-darkSurface-100"
                    style={{
                        width: "50px",
                        height: "38px",
                        border: "none",
                    }}
                    onChange={handleChange}
                    onKeyUp={handleKeyUp}
                />
            </div>
            <ToolTip text={translateFunc("increase-font-size")}>
                <button
                    className="border border-irGray-200 dark:border-darkSurface-400 px-4 font-semibold h-10 rounded-r-xl flex items-center justify-center hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    onClick={handlePlusClick}
                >
                    <PlusIcon />
                </button>
            </ToolTip>
        </div>
    );
};
